export const ORDER_STATUSES = ['Ordered', 'Payment Pending', 'Payment Confirmed', 'Packed', 'Shipped', 'Delivered', 'Cancelled'];
export const STOCK_STATUSES = ['In Stock', 'Preorder', 'Out of Stock'];
export const CARRIERS = ['Australia Post', 'StarTrack', 'Sendle', 'Aramex', 'DHL', 'Other'];
export const CARRIER_URLS = {
  'Australia Post': 'https://auspost.com.au/mypost/track/#/details/{t}',
  'StarTrack': 'https://startrack.com.au/track/?consignmentNumber={t}',
  'Sendle': 'https://track.sendle.com/tracking?ref={t}',
  'Aramex': 'https://www.aramex.com.au/tools/track?l={t}',
  'DHL': 'https://www.dhl.com/au-en/home/tracking.html?tracking-id={t}',
};
export const trackingUrl = (carrier, t) =>
  t && CARRIER_URLS[carrier] ? CARRIER_URLS[carrier].replace('{t}', encodeURIComponent(t)) : null;

// Australian phone -> international WhatsApp format (0XXXXXXXXX -> 61XXXXXXXXX)
export const toAuWhatsApp = (phone) => {
  const digits = (phone || '').replace(/[^0-9]/g, '');
  if (digits.startsWith('61')) return digits;
  if (digits.startsWith('0')) return '61' + digits.slice(1);
  return digits;
};
// Native SMS link with pre-filled tracking text (for customers without WhatsApp).
export const smsLink = (o) => {
  const num = toAuWhatsApp(o.customer?.phone);
  const url = trackingUrl(o.carrier, o.trackingNumber);
  const msg =
    `Hi ${o.customer?.fullName || ''}, your Australian Luxe Peptides order ${o.orderNumber} has shipped` +
    (o.carrier ? ` with ${o.carrier}` : '') + '.' +
    (o.trackingNumber ? ` Tracking #: ${o.trackingNumber}.` : '') +
    (url ? ` Track it here: ${url}` : '');
  return `sms:+${num}?&body=${encodeURIComponent(msg)}`;
};

export const whatsappLink = (o) => {
  const num = toAuWhatsApp(o.customer?.phone);
  const url = trackingUrl(o.carrier, o.trackingNumber);
  const products = (o.items || []).map((i) => `${i.name} x${i.qty}`).join(', ');
  const msg =
    `Hi ${o.customer?.fullName || ''}, this is Australian Luxe Peptides regarding your order ${o.orderNumber}. ` +
    `Items: ${products}. Total: $${Number(o.total || 0).toFixed(2)} AUD. Status: ${o.orderStatus}.` +
    (o.trackingNumber ? ` Carrier: ${o.carrier || 'Carrier'}, Tracking: ${o.trackingNumber}.` : '') +
    (url ? ` Track: ${url}` : '');
  return `https://wa.me/${num}?text=${encodeURIComponent(msg)}`;
};

// Order is "due for a review request" 10+ days after it was placed (and not cancelled).
export const REVIEW_DUE_DAYS = 10;
export const daysSincePlaced = (o) => {
  const created = o.createdAt ? new Date(o.createdAt) : null;
  if (!created || isNaN(created)) return null;
  return Math.floor((Date.now() - created.getTime()) / 86400000);
};
export const isReviewDue = (o) => {
  const d = daysSincePlaced(o);
  return d != null && d >= REVIEW_DUE_DAYS && o.orderStatus !== 'Cancelled';
};
export const reviewWhatsappLink = (o) => {
  const num = toAuWhatsApp(o.customer?.phone);
  let base = '';
  try { base = window.location.origin; } catch (e) { base = ''; }
  const reviewsUrl = base ? `${base}/reviews` : '';
  const msg =
    `Thank you so much for your support. It would mean the world to me if you could please leave a review of your experience with service and product whether it was good or bad. Thank you again, AUSTRALIANLUXE xx` +
    (reviewsUrl ? ` ${reviewsUrl}` : '');
  return `https://wa.me/${num}?text=${encodeURIComponent(msg)}`;
};

export const EMPTY_PRODUCT = { name: '', code: '', size: '', price: 0, compareAtPrice: 0, image: '', coaImages: [], category: 'Fat Loss & Metabolism', stockStatus: 'In Stock', description: '', coa: false, featured: false, inventory: 0, ribbon: '', hidden: false, addon: false, bundle: false, bundleItems: [], supplierCost: 0, extraCost: 0, weight: 0, seoTitle: '', seoDescription: '' };
export const EMPTY_DISCOUNT = { code: '', type: 'percentage', amount: 0, freeProductId: '', minOrder: 0, expiry: '', usageLimit: '', active: true, vip: false, description: '', affiliate: false, affiliateName: '', commissionPercent: 0, restrictEmail: '' };
export const PROMO_TYPES = ['General', 'Free Shipping', 'Birthday Week', 'Golden Ticket', 'Mystery Prize', 'Bundle', 'Preorder Cut-off'];
export const EMPTY_PROMO = { type: 'General', name: '', description: '', promoText: '', image: '', buttonText: '', buttonLink: '', active: true, startDate: '', endDate: '' };
export const EMPTY_INCOMING = { name: '', note: '', eta: '', image: '', active: true, productId: '', qty: 0 };
export const EMPTY_LIB_ITEM = { title: '', body: '', image: '', category: 'General', active: true, order: 0, productId: '', whatItIs: '', use: '', bacWater: '', dosage: '', timing: '', cycle: '' };
export const EMPTY_REVIEW = { name: '', rating: 5, body: '', date: '', productName: '', featured: false, active: true, order: 0 };
